import { render, staticRenderFns } from "./ApkBooks.vue?vue&type=template&id=6ac8b85a&"
import script from "./ApkBooks.vue?vue&type=script&lang=js&"
export * from "./ApkBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports